export const FULL_MULTIPAGE = {
    locale: "cs",
    completedHtml: {
        cs: "⏳",
    },
    loadingHtml: {
        cs: "⏳",
    },
    pages: [
        {
            name: "page1",
            title: {
                cs: "Základní údaje",
            },
            elements: [
                {
                    type: "text",
                    name: "person_code",
                    title: {
                        cs: "Rodné číslo",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatné rodné číslo",
                            },
                            expression: "cz_birth_num({person_code})",
                        },
                    ],
                    maskType: "pattern",
                    maskSettings: {
                        pattern: "999999/9999",
                    },
                },
                {
                    type: "text",
                    name: "first_name",
                    title: {
                        cs: "Jméno",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        default: "Required",
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatný formát hodnoty",
                            },
                            expression: "{first_name} empty or name_unicode({first_name})",
                        },
                        {
                            type: "text",
                            text: {
                                cs: "Zadejte prosím méně než 63 znaků.",
                            },
                            maxLength: 63,
                        },
                    ],
                },
                {
                    type: "text",
                    name: "last_name",
                    startWithNewLine: false,
                    title: {
                        cs: "Příjmení",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        default: "Required",
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatný formát hodnoty",
                            },
                            expression: "{last_name} empty or name_unicode({last_name})",
                        },
                        {
                            type: "text",
                            text: {
                                cs: "Zadejte prosím méně než 63 znaků.",
                            },
                            maxLength: 63,
                        },
                    ],
                },
                {
                    type: "text",
                    name: "email",
                    title: "Email",
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                        default: "Required",
                    },
                    validators: [
                        {
                            type: "email",
                            text: {
                                cs: "Zadejte prosím platnou e-mailovou adresu",
                            },
                        },
                        {
                            type: "text",
                            text: {
                                cs: "Zadejte prosím méně než 255 znaků.",
                            },
                            maxLength: 255,
                        },
                    ],
                    inputType: "email",
                    autocomplete: "email",
                    placeholder: "vas@email.cz",
                },
                {
                    type: "text",
                    name: "mobile_phone",
                    title: {
                        cs: "Telefonní číslo",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        default: "Required",
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "regex",
                            text: {
                                cs: "Neplatné telefonní číslo",
                            },
                            regex: "^(\\+420)?(71|72|73|77|601|602|603|604|605|606|607|608|702|703|704|705|706|707|708|709|721|722|723|724|725|726|727|728|729|790|792|797|799|2|31|32|35|37|38|39|41|47|46|48|49|51|53|54|55|56|57|58|59)",
                        },
                        {
                            type: "regex",
                            text: {
                                cs: "Neplatné telefonní číslo",
                            },
                            regex: "^(\\+420)?[\\d]{9}$",
                        },
                    ],
                    inputType: "tel",
                    maskType: "pattern",
                    maskSettings: {
                        pattern: "\\+\\4\\2\\0 999 999 999",
                    },
                },
                {
                    type: "checkbox",
                    name: "remarketing_agree",
                    titleLocation: "hidden",
                    choices: [
                        {
                            value: "1",
                            text: {
                                cs: "Souhlasím s poskytnutím osobních údajů pro účely [marketingové komunikace](/remarketing)",
                            },
                        },
                    ],
                },
                {
                    type: "html",
                    name: "consent_notice",
                    html: {
                        cs: 'Stisknutím tlačítka "Pokračovat" potvrzuji svůj souhlas <a href="/terms" target="_blank">Obchodními podmínkami</a> a <a href="/gdpr" target="_blank">zpracováním osobních údajů</a>.',
                    },
                },
            ],
        },
        {
            name: "address_info",
            title: {
                cs: "Adresa trvalého pobytu",
                default: "Contact information",
            },
            elements: [
                {
                    type: "text",
                    name: "city",
                    title: {
                        cs: "Město",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            maxLength: 63,
                        },
                    ],
                },
                {
                    type: "text",
                    name: "street",
                    startWithNewLine: false,
                    title: {
                        cs: "Ulice",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            maxLength: 63,
                        },
                    ],
                },
                {
                    type: "text",
                    name: "house_number",
                    title: {
                        cs: "Číslo popisné",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            minLength: 1,
                            maxLength: 10,
                        },
                    ],
                },
                {
                    type: "text",
                    name: "zip",
                    startWithNewLine: false,
                    title: {
                        cs: "PSČ",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            minLength: 5,
                            maxLength: 5,
                        },
                        {
                            type: "expression",
                            text: {
                                cs: "Toto pole je povinné",
                            },
                            expression: "{zip} empty or digits_only({zip})",
                        },
                    ],
                    maskType: "pattern",
                    maskSettings: {
                        pattern: "99999",
                    },
                },
            ],
        },
        {
            name: "income",
            title: {
                cs: "Další informace",
            },
            elements: [
                {
                    type: "text",
                    name: "identity_card_number",
                    title: {
                        cs: "Číslo občanského průkazu",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            text: {
                                cs: "Neplatné číslo občanského průkazu",
                            },
                            minLength: 9,
                            maxLength: 9,
                        },
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatné číslo občanského průkazu",
                            },
                            expression:
                                "{identity_card_number} empty or digits_only({identity_card_number})",
                        },
                    ],
                    maxLength: 9,
                },
                {
                    type: "dropdown",
                    name: "income_type",
                    title: {
                        cs: "Zdroj Vašich příjmů",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            expression:
                                "{income_type} empty or {income_type} anyof ['PART_TIME_EMPLOYMENT', 'UNEMPLOYED', 'WORKING_PENSIONER', 'PENSION_SELF_EMPLOYED', 'STUDENT', 'MATERNITY_LEAVE', 'PENSION', 'SELF_EMPLOYED', 'EMPLOYED']",
                        },
                    ],
                    choices: [
                        {
                            value: "EMPLOYED",
                            text: {
                                cs: "Zaměstnanec",
                            },
                        },
                        {
                            value: "SELF_EMPLOYED",
                            text: {
                                cs: "OSVČ",
                            },
                        },
                        {
                            value: "PENSION",
                            text: {
                                cs: "Důchodce",
                            },
                        },
                        {
                            value: "MATERNITY_LEAVE",
                            text: {
                                cs: "Mateřská / Rodičovská",
                            },
                        },
                        {
                            value: "STUDENT",
                            text: {
                                cs: "Student",
                            },
                        },
                        {
                            value: "PENSION_SELF_EMPLOYED",
                            text: {
                                cs: "Důchodce OSVČ",
                            },
                        },
                        {
                            value: "WORKING_PENSIONER",
                            text: {
                                cs: "Pracující důchodce",
                            },
                        },
                        {
                            value: "UNEMPLOYED",
                            text: {
                                cs: "Nezaměstnaný",
                            },
                        },
                        {
                            value: "PART_TIME_EMPLOYMENT",
                            text: {
                                cs: "Částečný úvazek",
                            },
                        },
                    ],
                },
                {
                    type: "slider",
                    name: "monthly_income",
                    title: {
                        cs: "Čistý měsíční příjem (v Kč)",
                    },
                    defaultValue: 5000,
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            expression:
                                "{monthly_income} empty or ({monthly_income} <= 250000 and {monthly_income} >= 0)",
                        },
                    ],
                    min: 5000,
                    max: 95000,
                    step: 1000,
                    customLabels: [
                        {
                            value: 10000,
                            text: {
                                default: "",
                                cs: "10 000",
                            },
                        },
                        {
                            value: 50000,
                            text: {
                                default: "90 001",
                                cs: "50 000",
                            },
                        },
                        {
                            value: 90000,
                            text: {
                                default: "",
                                cs: "90 000",
                            },
                        },
                    ],
                    tooltipVisibility: "always",
                    tooltipFormat: "{0} Kč",
                    labelCount: 3,
                },
                {
                    type: "slider",
                    name: "expenses",
                    title: {
                        cs: "Přibližné měsíční výdaje (v Kč)",
                    },
                    defaultValue: 1000,
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            expression:
                                "{expenses} empty or ({expenses} <= 250000 and {expenses} >= 0)",
                        },
                    ],
                    min: 1000,
                    max: 70000,
                    step: 1000,
                    customLabels: [
                        {
                            value: 5000,
                            text: {
                                default: "",
                                cs: "5 000",
                            },
                        },
                        {
                            value: 35000,
                            text: {
                                default: "1000",
                                cs: "35 000",
                            },
                        },
                        {
                            value: 65000,
                            text: {
                                default: "35001",
                                cs: "65 000",
                            },
                        },
                    ],
                    tooltipVisibility: "always",
                    tooltipFormat: "{0} Kč",
                    labelCount: 3,
                },
            ],
        },
        {
            name: "Employment",
            visibleIf: "{income_type} = 'EMPLOYED' or {income_type} = 'PART_TIME_EMPLOYMENT'",
            title: {
                cs: "Zaměstnání",
            },
            elements: [
                {
                    type: "text",
                    name: "employer",
                    title: {
                        cs: "Zaměstnavatel",
                    },
                    requiredIf:
                        "{income_type} = 'EMPLOYED' or {income_type} = 'PART_TIME_EMPLOYMENT'",
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            maxLength: 127,
                        },
                    ],
                    autocomplete: "organization",
                },
                {
                    type: "text",
                    name: "workplace_address",
                    title: {
                        cs: "Adresa zaměstnavatele ",
                    },
                    requiredIf:
                        "{income_type} = 'EMPLOYED' or {income_type} = 'PART_TIME_EMPLOYMENT'",
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            maxLength: 255,
                        },
                    ],
                },
                {
                    type: "text",
                    name: "workplace_position",
                    title: {
                        cs: "Pracovní pozice ",
                    },
                    requiredIf:
                        "{income_type} = 'EMPLOYED' or {income_type} = 'PART_TIME_EMPLOYMENT'",
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            maxLength: 127,
                        },
                    ],
                },
                {
                    type: "text",
                    name: "year_month_of_working",
                    title: {
                        cs: "Pracuji zde od",
                    },
                    requiredIf:
                        "{income_type} = 'EMPLOYED' or {income_type} = 'PART_TIME_EMPLOYMENT'",
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            text: {
                                cs: "Toto pole je povinné",
                            },
                            expression:
                                "{year_month_of_working} empty or year_month_interval({year_month_of_working}, '1965-01', today())",
                        },
                    ],
                    inputType: "month",
                    min: "1965-01",
                },
            ],
        },
        {
            name: "self_employed",
            visibleIf: "{income_type} = 'SELF_EMPLOYED' or {income_type} = 'PENSION_SELF_EMPLOYED'",
            title: {
                cs: "Podnikání",
            },
            elements: [
                {
                    type: "text",
                    name: "company_number",
                    title: {
                        cs: "IČO",
                    },
                    requiredIf:
                        "{income_type} = 'SELF_EMPLOYED' or {income_type} = 'PENSION_SELF_EMPLOYED'",
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            text: {
                                cs: "Neplatné IČO",
                            },
                            minLength: 8,
                            maxLength: 8,
                        },
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatné IČO",
                            },
                            expression: "{company_number} empty or digits_only({company_number})",
                        },
                    ],
                    maskType: "pattern",
                    maskSettings: {
                        pattern: "99999999",
                    },
                },
            ],
        },
        {
            name: "financial_info",
            title: {
                cs: "Kam chcete obdržet peníze?",
            },
            elements: [
                {
                    type: "text",
                    name: "bank_account_prefix",
                    title: {
                        cs: "Předčíslí",
                    },
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "text",
                            text: {
                                cs: "Neplatné předčíslí",
                            },
                            maxLength: 6,
                        },
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatné předčíslí",
                            },
                            expression:
                                "{bank_account_prefix} empty or cz_bank_prefix({bank_account_prefix})",
                        },
                    ],
                    maxLength: 6,
                },
                {
                    type: "text",
                    name: "account_number",
                    startWithNewLine: false,
                    title: {
                        cs: "Číslo účtu",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatné číslo účtu",
                            },
                            expression:
                                "{account_number} empty or cz_bank_account({account_number})",
                        },
                        {
                            type: "text",
                            text: {
                                cs: "Neplatné číslo účtu",
                            },
                            minLength: 2,
                            maxLength: 10,
                        },
                    ],
                    maxLength: 10,
                },
                {
                    type: "dropdown",
                    name: "bank_code",
                    title: {
                        cs: "Kód banky",
                    },
                    isRequired: true,
                    requiredErrorText: {
                        cs: "Toto pole je povinné",
                    },
                    validators: [
                        {
                            type: "expression",
                            text: {
                                cs: "Neplatný kód banky",
                            },
                            expression:
                                "{bank_code} empty or ({bank_code} anyof ['0800', '0300', '0100', '3030', '5500', '0600', '2010', '2700', '6210', '2250', '2070', '2200', '2220', '5800', '6000', '8030', '8040', '6363'])",
                        },
                    ],
                    choices: [
                        {
                            value: "0800",
                            text: {
                                cs: "0800-Česká spořitelna, a.s.",
                            },
                        },
                        {
                            value: "0300",
                            text: {
                                cs: "0300-Československá obchodní banka, a. s.",
                            },
                        },
                        {
                            value: "0100",
                            text: {
                                cs: "0100-Komerční banka, a.s.",
                            },
                        },
                        {
                            value: "3030",
                            text: {
                                cs: "3030-Air Bank a.s.",
                            },
                        },
                        {
                            value: "5500",
                            text: {
                                cs: "5500-Raiffeisenbank a.s.",
                            },
                        },
                        {
                            value: "0600",
                            text: {
                                cs: "0600-MONETA Money Bank, a.s.",
                            },
                        },
                        {
                            value: "2010",
                            text: {
                                cs: "2010-Fio banka, a.s.",
                            },
                        },
                        {
                            value: "2700",
                            text: {
                                cs: "2700-UniCredit Bank Czech Republic and Slovakia, a.s.",
                            },
                        },
                        {
                            value: "6210",
                            text: {
                                cs: "6210-mBank S.A., organizační složka",
                            },
                        },
                        {
                            value: "2250",
                            text: {
                                cs: "2250-Banka CREDITAS a.s.",
                            },
                        },
                        {
                            value: "2070",
                            text: {
                                cs: "2070-TRINITY BANK a.s.",
                            },
                        },
                        {
                            value: "2200",
                            text: {
                                cs: "2200-Peněžní dům, spořitelní družstvo",
                            },
                        },
                        {
                            value: "2220",
                            text: {
                                cs: "2220-Artesa, spořitelní družstvo ",
                            },
                        },
                        {
                            value: "5800",
                            text: {
                                cs: "5800-J&T BANKA, a.s.",
                            },
                        },
                        {
                            value: "6000",
                            text: {
                                cs: "6000-PPF banka a.s.",
                            },
                        },
                        {
                            value: "8030",
                            text: {
                                cs: "8030-Volksbank Raiffeisenbank Nordoberpfalz eG pobočka Cheb",
                            },
                        },
                        {
                            value: "8040",
                            text: {
                                cs: "8040-Oberbank AG pobočka Česká republika",
                            },
                        },
                        {
                            value: "6363",
                            text: {
                                cs: "6363-Partners Banka, a.s.",
                            },
                        },
                    ],
                },
            ],
        },
    ],
    showTitle: false,
    questionErrorLocation: "bottom",
    showProgressBar: true,
    progressBarShowNavigationText: true,
    checkErrorsMode: "onValueChanged",
    textUpdateMode: "onTyping",
    pagePrevText: {
        default: "Previous",
        cs: "Předchozí",
    },
    pageNextText: {
        default: "Proceed",
        cs: "Pokračovat",
    },
    completeText: {
        default: "GET MONEY",
        cs: "ZÍSKAT PENÍZE",
    },
};
